const BOOLEAN_FIELD_PATTERN = /^[a-z]+_(?:fun_)?is_/;

const DATE_FIELD_PATTERN = /^[a-z]+_(?:fun_)?d_/;

const NUMBER_FIELD_PATTERN = /^[a-z]+_(?:fun_)?nr_/;

/**
 * Of het attribuut een boolean is, afgeleid uit de naam van het laatste deel van het pad
 * (`ds_is_bevorderd`, `cf_fun_is_plaatsing_actueel`).
 */
export function isBooleanAttribute(attr: readonly string[] | string): boolean {
	return isAttributeOfType(attr, BOOLEAN_FIELD_PATTERN);
}

/**
 * Of het attribuut een datum is, afgeleid uit de naam van het laatste deel van het pad
 * (`aw_d_datum.per_d_datum`).
 */
export function isDateAttribute(attr: readonly string[] | string): boolean {
	return isAttributeOfType(attr, DATE_FIELD_PATTERN);
}

/**
 * Of het attribuut een getal is, afgeleid uit de naam van het laatste deel van het pad
 * (`ds_nr_leerjaar_van`).
 */
export function isNumberAttribute(attr: readonly string[] | string): boolean {
	return isAttributeOfType(attr, NUMBER_FIELD_PATTERN);
}

function isAttributeOfType(attr: readonly string[] | string, pattern: RegExp): boolean {
	const parts = typeof attr === 'string' ? attr.split('.') : attr;
	return pattern.test(parts[parts.length - 1]);
}
